import {
    Dialog,
    DialogContent,
    DialogHeader,
    DialogTitle,
    DialogDescription,
    DialogFooter,
} from '@/components/ui/dialog'
import { Button } from '@/components/ui/button'
import { Play } from 'lucide-react'
import { useTranslation } from 'react-i18next'

export function LessonReadyModal({ topic, imageUrl, open, onPresent, onClose }: {
    topic: string
    imageUrl?: string
    open: boolean
    onPresent: () => void
    onClose: () => void
}) {
    const { t } = useTranslation()
    return (
        <Dialog open={open} onOpenChange={(o) => { if (!o) onClose() }}>
            <DialogContent data-testid="lesson-ready-modal">
                {imageUrl && (
                    <img
                        src={imageUrl}
                        alt=""
                        className="mb-2 aspect-video w-full rounded-lg object-cover"
                    />
                )}
                <DialogHeader>
                    <DialogTitle>{t('lesson-ready-title', { topic })}</DialogTitle>
                    <DialogDescription>{t('lesson-ready-description')}</DialogDescription>
                </DialogHeader>
                <DialogFooter className="gap-2 sm:gap-2">
                    <Button variant="ghost" data-testid="lesson-ready-dismiss" onClick={onClose}>{t('lesson-ready-dismiss')}</Button>
                    <Button data-testid="lesson-ready-present" onClick={onPresent}>
                        <Play className="mr-2 h-4 w-4" /> {t('lesson-ready-present')}
                    </Button>
                </DialogFooter>
            </DialogContent>
        </Dialog>
    )
}
